var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "15", height: "9", viewBox: "0 0 15 9", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2 1.5l5.5 6 5.5-6", className: styles["arrow-shape"] || "arrow-shape", stroke: "#DBDBDB", strokeWidth: "2.3", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});